<template>
    <el-container id="tab">
        <el-aside class="aside-box" :width="isCollapse ? '20px' : '320px'">
            <el-card v-show="!isCollapse" shadow="never">
                <div slot="header">
                    <span>查询条件</span>
                    <el-button style="float: right; padding: 3px 0;" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
                </div>
                <el-form label-width="80px" :model="queryForm" ref="queryFormRef" status-icon>
                    <el-scrollbar>
                        <el-form-item label="查询范围" prop="billType.selected">
                            <el-select v-model="queryForm.billType.selected" placeholder="请选择查询范围" clearable style="width: 100%;">
                                <el-option key="A" label="普通销售" value="A"></el-option>
                                <el-option key="D" label="订单销售" value="D"></el-option>
                                <el-option key="B" label="还货单" value="B"></el-option>
                                <el-option key="C" label="退货单" value="C"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单据日期" prop="billDate.selected">
                            <date-picker style="width: 100%;" v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                            </date-picker>
                        </el-form-item>
                        <el-form-item label="大类" prop="brand.selected">
                            <select-multiple style="width: 100%;" v-bind:select-data="queryForm.brand"></select-multiple>
                        </el-form-item>
                        <el-form-item label="小类" prop="brandType.selected">
                            <select-multiple style="width: 100%;" v-bind:select-data="queryForm.brandType"></select-multiple>
                        </el-form-item>
                        <el-form-item label="商品" prop="product.selected">
                            <el-select class="select_multiple" ref="productSelectRef" style="width: 100%;" v-model="queryForm.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称" @focus="productInputFocus" @change="productChange">
                                <el-option v-for="item in queryForm.product.list" :key="item.value" :label="item.text" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="部门" prop="department.selected">
                            <select-multiple style="width: 100%;" v-bind:select-data="queryForm.department"></select-multiple>
                        </el-form-item> -->
                        <el-form-item label="业务员" prop="salesman.selected">
                            <select-multiple style="width: 100%;" v-bind:select-data="queryForm.salesman"></select-multiple>
                        </el-form-item>
                        <el-form-item label="配送员" prop="deliverUser.selected">
                            <select-multiple style="width: 100%;" v-bind:select-data="queryForm.deliverUser"></select-multiple>
                        </el-form-item>
                        <el-form-item label="仓库" prop="inWarehouse.selected">
                            <select-multiple style="width: 100%;" v-bind:select-data="queryForm.inWarehouse"></select-multiple>
                        </el-form-item>
                        <el-form-item label="所属公司" prop="subCompanyID.selected">
                            <select-multiple style="width: 100%;" :select-data="queryForm.subCompanyID" is-scroll></select-multiple>
                        </el-form-item>
                        <el-form-item label="客户类型" prop="customerTypes.selected">
                            <select-multiple style="width: 100%;" v-bind:select-data="queryForm.customerTypes"></select-multiple>
                        </el-form-item>
                        <el-form-item label="所属片区" prop="domainDesc.selected">
                            <select-multiple style="width: 100%;" v-bind:select-data="queryForm.domainDesc"></select-multiple>
                        </el-form-item>
                        <el-form-item label="客户" prop="customer.selected">
                            <select-multiple style="width: 100%;" :select-data="queryForm.customer" is-scroll isTable :column-list="selectMultipleTableColumnListCommon.customer"></select-multiple>
                        </el-form-item>
                        <el-form-item label="销售形式" prop="isLargess.selected">
                            <!-- <el-select class="select_multiple" v-model="queryForm.isLargess.selected" placeholder="请选择查询范围" clearable multiple value-key="value" style="width: 100%;">
                                <el-option v-for="item in isLargessInfo" :key="item.value" :label="item.text" :value="item"></el-option>
                            </el-select> -->
                            <select-multiple style="width: 100%;" v-bind:select-data="queryForm.isLargess"></select-multiple>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark.selected">
                            <el-input placeholder="请输入备注" v-model.trim="queryForm.remark.selected" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="filterPriceZero.selected">
                            <el-checkbox v-model="queryForm.filterPriceZero.selected" true-label="Y" false-label="N">过滤正常销售价格为零商品</el-checkbox>
                        </el-form-item>
                        <el-form-item prop="filterExchangeBill.selected">
                            <el-checkbox v-model="queryForm.filterExchangeBill.selected" true-label="Y" false-label="N">过滤换货和延迟换货</el-checkbox>
                        </el-form-item>
                    </el-scrollbar>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                        <el-button @click="onReset">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
            <div class="isCollapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
                <span style="text-align: center;">查询</span>
                <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
                <span style="text-align: center;">条件</span>
            </div>
        </el-aside>
        <el-main class="main-box">
            <el-card shadow="never" style="position: relative;">
                <el-form :inline="true" style="height: 41px; overflow-y: auto; width: calc(100% - 70px);">
                    <el-form-item>
                        {{params.beginDate}}
                        <span style="margin: 0 6px;">至</span>
                        {{params.endDate}}
                    </el-form-item>
                    <el-form-item label="查询范围:">
                        {{ params.billType == 'A' ? '普通销售' : (params.billType == 'B' ? '还货单' : (params.billType == 'C' ? '退货单' : (params.billType == 'D' ? '订单销售' : '全部'))) }}
                    </el-form-item>
                    <el-form-item label="仓库:">
                        {{inWarehouse}}
                    </el-form-item>
                    <el-form-item label="业务员:">
                        {{salesman}}
                    </el-form-item>
                    <el-form-item label="销售形式:">
                        {{isLargess}}
                    </el-form-item>
                    <el-form-item style="position: absolute; top: 12px; right: 10px;">
                        <el-button type="success" @click="exportExcel">导出</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
            <div class="table">
                <el-table ref="isLargess" tag="isLargess" v-loading="tableIsLoading" :data="tableList" height="100%" max-height="100%" :show-summary="true" :summary-method="getSummaries" border>
                    <el-table-column type="index" align="center" fixed width="40">
                        <!-- <template slot="header">
                            <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                                <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                            </el-tooltip>
                        </template> -->
                    </el-table-column>
                    <el-table-column label="商品" prop="itemName" width="180" fixed></el-table-column>
                    <el-table-column label="规格" prop="itemSpec" width="80" fixed></el-table-column>
                    <el-table-column label="条码" prop="barCode" width="150">
                        <template slot-scope="scope">
                            <div class="number-box">
                                <p v-if="scope.row.salBarCode">{{scope.row.salBarCode}}/大</p>
                                <p v-if="scope.row.midBarCode">{{scope.row.midBarCode}}/中</p>
                                <p v-if="scope.row.invBarCode">{{scope.row.invBarCode}}/小</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="总数量" prop="billQtyFormat" width="130"></el-table-column>
                    <el-table-column label="大单位数量" prop="salBillQty" width="120"></el-table-column>
                    <el-table-column label="小单位数量" prop="invQty" width="120"></el-table-column>
                    <el-table-column label="总金额(元)" prop="totalAmt" width="120"></el-table-column>
                    <el-table-column label="兑奖" prop="prizeQtyFormat" width="100"></el-table-column>
                    <el-table-column label="促销数量" prop="promotionQtyFormat" width="120"></el-table-column>
                    <el-table-column label="促销赠品数量" prop="promotionLargessQtyFormat" width="120"></el-table-column>
                    <el-table-column :label="item.label" :prop="item.prop" v-for="item in tableColumnList" :key="item.prop"></el-table-column>
                </el-table>
            </div>
            <!-- <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination> -->
        </el-main>
        <el-dialog title="选择商品" :visible.sync="selectProductVisible" width="1080px" :close-on-click-modal="false" custom-class="product-dialog">
            <selectProduct :args="{ isFitterEnabled: 'N' }" v-if="selectProductVisible" @get-product-data="getProductData" :default-checked-keys="queryForm.product.list"></selectProduct>
        </el-dialog>
        <el-dialog title="自定义显示列" :visible.sync="dialogVisible" width="20%" @close="dialogClose">
            <custom-columns ref="customColumns" v-if="dialogVisible"></custom-columns>
        </el-dialog>
    </el-container>
</template>
<script>
import datePicker from '@/components/common/datePicker.vue'
import selectProduct from '@/components/common/selectProduct.vue'
import customColumns from '@/components/common/customColumns.vue'
import { pickerOptions, getNowFormatDate, getAddDate, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
    name: "SaleCollectQuery",
    components: {
        datePicker,
        selectProduct,
    },
    mixins: [selectMultipleTableColumnListCommonMixins],
    data() {
        return {
            isCollapse: true,
            pickerOptions: pickerOptions,
            selectProductVisible: false,
            queryForm: {
                billType: { submitName: 'billType', selected: '' },
                billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
                product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                // department: { submitName: 'departmentID', selected: [], isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择部门', request: { url: '/Account/departmentDefine/selectDepartmentDownListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: ''}},
                brand: { submitName: 'brandID', selected: [], isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
                brandType: { submitName: 'itemTypeID', selected: [], isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
                salesman: { submitName: 'salesmanID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                deliverUser: { submitName: 'deliverUserID', selected: [], isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择配送员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                inWarehouse: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                customerTypes: { submitName: 'classifyID', selected: [], isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户类型', request: { url: '/Account/customerTypeDefine/getCustomerTypesForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                domainDesc: { submitName: 'domainID', selected: [], isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择所属片区', request: { url: '/Account/domainDefine/getDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                subCompanyID: { submitName: 'subCompanyID', selected: '', isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: true, list: [], label: 'label', value: 'value', placeholder: '请选择所属公司', request: { url: '/Account/customerDefineVue/selectChainStoresList.html', type: 'post', params: { page: 1, size: 10 }, text: '', value: '' } },
                customer: { submitName: 'customerID', selected: [], isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 10 }, text: '', value: '' } },
                isLargess: { submitName: 'isLargess', selected: [], isMultiple: true, isAll: false, isShowAll: false, valueIsObj: true, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择销售形式', request: { url: '/Account/salSaleType/querySalSaleList.html', type: 'post', params: { page: 1, size: 100, isPage: 'N' }, text: '', value: '' } },
                // isLargess: { submitName: 'saleType', selected: [], valueIsObj: true },
                filterPriceZero: { submitName: 'isZeroPrize', selected: 'N' },
                filterExchangeBill: { submitName: 'filterExchangeBill', selected: 'N' },
                remark: { submitName: 'remark', selected: '' }
            },
            isLargessInfo: [
                { value: 'A', text: '正常' },
                { value: 'B', text: '退货' },
                { value: 'C', text: '促销' },
                { value: 'D', text: '特价' },
                { value: 'E', text: '兑奖' },
                { value: 'F', text: '正常销售赠品' },
                { value: 'G', text: '促销赠品' },
                { value: 'h', text: '还货赠品' }
            ],
            inWarehouse: '全部',
            salesman: '全部',
            isLargess: '全部',
            params: {
                beginDate: getAddDate(-3),
                endDate: getNowFormatDate(),
                collectType: 'C',
                searchType: 'A',
                filterExchangeBill: 'N', // 是否过滤换货和延时换货 Y 过滤 N不过滤(默认)
                url: '/Account/saleCollectVue/saleCollectQuery.html',
            },
            tableIsLoading: false,
            tableList: [],
            allowCostPrice: false,
            dialogVisible: false,
            summaries: {},
            tableColumnList: []
        }
    },
    created() {
        this.getTableColumn()
        this.getTableList()
    },
    watch: {
        'queryForm.customerTypes.selected'(val) {
            let tempArr = []
            val.map(item => {
                tempArr.push("'" + item + "'")
            })
            this.queryForm.customer.request.params.classifyID = tempArr.join(',')
            this.queryForm.customer.isReSearch = true
        },
        'queryForm.domainDesc.selected'(val) {
            let tempArr = []
            val.map(item => {
                tempArr.push("'" + item + "'")
            })
            this.queryForm.customer.request.params.domainID = tempArr.join(',')
            this.queryForm.customer.isReSearch = true
        }
    },
    methods: {
        async getTableColumn() {
            const { data: res } = await this.$http.post('/Account/saleCollectVue/saleCollectQueryColumn.html', this.Qs.stringify(this.params))
            if (res.code != 'success') return false
            res.result = JSON.parse(res.result)
            console.log(JSON.parse(res.result.data))
            this.tableColumnList = JSON.parse(res.result.data)
        },
        async getTableList() {
            this.tableIsLoading = true
            const { data: res } = await this.$http.post(this.params.url, this.Qs.stringify(this.params))
            this.tableIsLoading = false
            if (res.code != 'success') return false
            res.result = JSON.parse(res.result)
            this.tableList = JSON.parse(res.result.data)
            this.summaries = res.result.sum ? JSON.parse(res.result.sum) : {}
        },
        // handleSizeChange (newSize) {
        //     this.params.size = newSize
        //     this.getTableList()
        // },
        // handleCurrentChange (newPage) {
        //     this.params.page = newPage
        //     this.getTableList()
        // },
        getSummaries(param) {
            const { columns } = param
            const sums = [];
            for (let key in this.summaries) {
                columns.forEach((column, index) => {
                    if (index == 1) {
                        sums[index] = '合计'
                        return
                    }
                    if (column.property == key) {
                        sums[index] = this.summaries[key]
                        return
                    }
                })
            }
            this.$nextTick(() => {
                this.$refs.isLargess.doLayout();
            })
            return sums
        },
        // 获取自定义列详情
        async getCustomColumn() {
            let funcCode = '204'
            const { data: res } = await $http({ url: '/Account/dataSearchVue/selectColumnByFuncCode.html', type: 'post', params: Qs.stringify({ funcCode: funcCode }) })
            if (res.code != 'success') return this.$message.error(res.message)
            this.customColumnList = JSON.parse(res.result)
        },
        getCustomColumns() {
            this.dialogVisible = true
            // let tempArr = this.$refs[this.tabsName].$refs[this.tabsName].$children.map((item, index) => {
            //     let _id = index + ''
            //     if (item.$children.length) {
            //         return {
            //             id: _id,
            //             prop: item.prop,
            //             isShow: "Y",
            //             children: item.$children.map((row, i) => ({
            //                 prop: row.prop,
            //                 id: _id + i,
            //                 isShow: "Y"
            //             }))
            //         }
            //     } else {
            //         return {
            //             prop: item.prop,
            //             id: _id,
            //             isShow: "Y"
            //         }
            //     }
            // }).filter(item => (item.prop))
            // console.log(tempArr)
            let tempArr = this.customColumnsFilterOfPower(this.isLargessList)
            let arr = []
            tempArr.forEach(item => {
                this.$refs[this.tabsName].customColumnList.forEach($item => {
                    if (item.prop == $item.prop) {
                        if (item.children && item.children.length) {
                            arr.push({
                                id: $item.id,
                                label: item.label,
                                prop: item.prop,
                                isShow: $item.isShow,
                                children: this.mergeArr(item.children, $item.children, 'prop')
                            })
                        } else {
                            arr.push({
                                id: $item.id,
                                label: item.label,
                                prop: item.prop,
                                isShow: $item.isShow
                            })
                        }
                    }
                })
            })
            this.$nextTick(() => {
                let element = this.$refs['customColumns']
                element.loading = false
                element.setCustomcolumns(arr)
            })
        },
        onReset() {
            this.$refs['queryFormRef'].resetFields()
        },
        onSubmit() {
            this.salesman = this.queryForm.salesman.selected.length ? this.queryForm.salesman.selected.map(item => (item.text)) : '全部'
            this.inWarehouse = this.queryForm.inWarehouse.selected.length ? this.queryForm.inWarehouse.selected.map(item => (item.text)) : '全部'
            this.isLargess = this.queryForm.isLargess.selected.length ? this.queryForm.isLargess.selected.map(item => (item.text)) : '全部'
            for (let i in this.queryForm) {
                if (typeof this.queryForm[i].selected == 'object') {
                    if (i == 'billDate') {
                        if (this.queryForm[i].selected) {
                            this.$set(this.params, 'beginDate', this.queryForm[i].selected[0])
                            this.$set(this.params, 'endDate', this.queryForm[i].selected[1])
                        } else {
                            this.$set(this.params, 'beginDate', '')
                            this.$set(this.params, 'endDate', '')
                        }
                        continue
                    }
                    let tempArr = []
                    this.queryForm[i].selected.map(item => {
                        if (this.queryForm[i].valueIsObj) {
                            tempArr.push("'" + item.value + "'")
                        } else {
                            tempArr.push("'" + item + "'")
                        }
                    })
                    this.$set(this.params, this.queryForm[i].submitName, tempArr.join(','))
                } else {
                    this.$set(this.params, this.queryForm[i].submitName, this.queryForm[i].selected)
                }
            }
            this.params.page = 1
            this.getTableColumn()
            this.getTableList()
            this.$nextTick(() => {
                this.$refs.isLargess.doLayout();
            })
        },
        productChange(val) {
            this.queryForm.product.list = val
        },
        productInputFocus() {
            this.$refs['productSelectRef'].blur()
            this.selectProductVisible = true
        },
        getProductData(data) {
            this.selectProductVisible = false
            this.$set(this.queryForm.product, 'list', data)
            this.$set(this.queryForm.product, 'selected', data)
        },
        dialogClose() {
            let $customColumns = this.$refs['customColumns']
            $customColumns.$nextTick(async () => {
                let { customColumns } = $customColumns
                const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
                    funcCode: 208,
                    customSetInfo: JSON.stringify(customColumns)
                }))
                if (res.code != 'success') return this.$message.error(res.message)
                this.$message.success(res.message)
                this.$emit('getCustomColumn')
            })
        },
        exportExcel() {
            let obj = { ...this.params }
            delete obj.url
            let $table = this.$refs['isLargess']
            let exportExcelUrl = '/Account/saleCollectVue/exportCollectQuery.html'
            let tempArr = $table.$children.map(item => {
                let _it = item._props
                if (_it.prop && _it.prop.match(/\//)) {
                    let label = _it.label.split('/')
                    let prop = _it.prop.split('/')
                    return [{
                            label: label[0],
                            prop: prop[0]
                        },
                        {
                            label: label[1],
                            prop: prop[1]
                        }
                    ]
                } else {
                    return {
                        label: _it.label,
                        prop: _it.prop
                    }
                }
            }).filter(item => (item.prop || Array.isArray(item))).flat()
            exportExcelCommonForVue(obj, tempArr, exportExcelUrl)
            console.log(tempArr)
        }
    }
};
</script>
<style scoped lang="less">
#tab {
    .isCollapse {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        border: 1px #DCDFE6 solid;
        cursor: pointer;
        background-color: rgba(83, 168, 255, 0.1);
        color: #409EFF;
    }

    /deep/.aside-box {
        height: 100%;
        overflow: hidden;

        .el-card {
            height: calc(100% - 2px);
        }

        .el-card__header {
            padding: 12px;
        }

        .el-card__body {
            padding: 6px;
            height: calc(100% - 53px);
        }

        .el-form {
            height: 100%;
        }

        .el-scrollbar {
            height: calc(100% - 40px);
        }

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        .el-scrollbar__bar {
            z-index: 999;
        }
    }

    /deep/.product-dialog {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        top: 50%;
        transform: translateY(-50%);
    }

    /deep/ .el-table--scrollable-x .el-table__body-wrapper {
        z-index: 2;
    }

    /deep/.main-box {
        padding: 0 20px;

        .el-card__body {
            padding: 12px 20px;
            max-height: 41px;

            .el-form-item {
                margin-bottom: 0;
            }
        }

        .table {
            height: calc(100% - 71px);

            .el-table {

                td,
                th {
                    padding: 6px 0;
                }
            }
        }

        // .el-pagination {
        //     margin-top: 16px;
        // }
    }
}
</style>